import { storyblokEditable } from "@storyblok/react";
import { ArrowRight } from "lucide-react";

const Hero = ({ blok }) => {
  return (
    <div
      {...storyblokEditable(blok)}
      className="font-display hero bg-radial-[at_50%_75%] from-tblue-800 from-40% to-tblack-900"
    >
      <div className="deltas"></div>
      <div className="container hero-content">
        <small className="tag">{blok.tag}</small>
        <h1>
          <span className="display-block">{blok.titlelineone}</span>
          <span className="display-block">{blok.titlelinetwo}</span>
        </h1>
        <p className="subtitle">{blok.subtitle}</p>
        <div className="button-wrap">
          <a href="/book-demo" className="button button-primary">
            Book a demo{" "}
            <ArrowRight size={24} fill="white" className="button-icon" />
          </a>
          {/* <a href="/contact-us" className="button button-secondary">
            Talk to sales{" "}
            <ArrowRight size={24} fill="currentcolor" className="button-icon" />
          </a> */}
        </div>
      </div>
    </div>
  );
};

export default Hero;
